import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";
import { ResourceAvatar } from "@common/resourceAvatar";
import { resource, ResourceTypes } from "@planzone/dto";

function Resource({ workLoad }: Props) {
  return (
    <div className={styles.resource}>
      <div className={styles.avatar}>
        <ResourceAvatar
          resource={{
            ...resource,
            name: workLoad.resourceName,
            type: workLoad.resourceType as ResourceTypes,
          }}
        />
      </div>
      <p className={styles.name}>{workLoad.resourceName}</p>
    </div>
  );
}

export { Resource };
